<template>
    <div id="page-not-found">
        <div class="door">
            <img src="@/assets/img/error-door.png" alt="" />
        </div>
        <div class="ground">
            <ci-button @click="$router.push('/projects')" type="blue" :text="$t('Views_Special_ThrottledPage_4')" />
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#page-not-found {
    display: flex;
    flex-direction: column;
    align-items: center;

    .ground {
        height: 226px;
        width: 100%;
        background: var(--secondary-1);
        position: absolute;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .door {
        width: 400px;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
            height: 500px;
            width: auto;
        }
    }
}

//Responsividade
@media (max-width: 1440px) {
    .ground {
        height: 100px !important;
    }

    .door {
        bottom: calc(226px - 194px) !important;
    }
}

@media (max-width: 567px) {
    #page-not-found {
        .door {
            width: 250px !important;
            left: calc(50% - 125px) !important;
            bottom: calc(226px - 176px) !important;
        }
    }
}
</style>
